/*******************************************************************************
 * Copyright (c) 2024 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

export interface EmailVerification {
  email?: string;
  loginId?: string;
  otp: string;
  product?: string;
}

export interface EmailVerificationApiRequest {
  email?: string;
  login_id?: string;
  otp: string;
  product?: string;
}

export const emailVerificationToApiRequest = (
  request: EmailVerification
): EmailVerificationApiRequest => {
  return {
    otp: request.otp,
    ...(request.email && {email: request.email}),
    ...(request.loginId && {login_id: request.loginId}),
    ...(request.product && {product: request.product}),
  };
};

// Resend email verification

export interface ResendEmailVerification {
  email?: string;
  loginId?: string;
  accountId?: string;
  product?: string;
}

export interface ResendEmailVerificationApiRequest {
  email?: string;
  login_id?: string;
  account_id?: string;
  product?: string;
}

export const resendEmailVerificationToApiRequest = (
  request: ResendEmailVerification
): ResendEmailVerificationApiRequest => {
  return {
    ...(request.email && {email: request.email}),
    ...(request.loginId && {login_id: request.loginId}),
    // ...(request.accountId && {account_id: request.accountId}),
    ...(request.product && {product: request.product}),
  };
};
